import { render, staticRenderFns } from "./TheSoftphoneWidget.vue?vue&type=template&id=33289143&scoped=true"
import script from "./TheSoftphoneWidget.vue?vue&type=script&lang=js"
export * from "./TheSoftphoneWidget.vue?vue&type=script&lang=js"
import style0 from "./TheSoftphoneWidget.vue?vue&type=style&index=0&id=33289143&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33289143",
  null
  
)

export default component.exports